export enum TagType {
  SPECIALTY = 'SPECIALTY',
  CATEGORY = 'CATEGORY',
  DISORDER = 'DISORDER',
  RADIOLOGY = 'RADIOLOGY',
  SURGICAL = 'SURGICAL',
  LABORATORY_TESTS = 'LABORATORY_TESTS',
  CLINICAL_MEASUREMENTS = 'CLINICAL_MEASUREMENTS',
  MEDICAL_DOCUMENTS = 'MEDICAL_DOCUMENTS',
  SURVEYS_AND_ASSESSMENTS = 'SURVEYS_AND_ASSESSMENTS',
  CERTAIN_INFECTIOUS_OR_PARASITIC_DISEASES = 'CERTAIN_INFECTIOUS_OR_PARASITIC_DISEASES',
  DISEASES_OF_THE_BLOOD_OR_BLOOD_FORMING_ORGANS = 'DISEASES_OF_THE_BLOOD_OR_BLOOD_FORMING_ORGANS',
  NEOPLASMS = 'NEOPLASMS',
  DISEASES_OF_THE_IMMUNE_SYSTEM = 'DISEASES_OF_THE_IMMUNE_SYSTEM',
  ENDOCRINE_NUTRITIONAL_OR_METABOLIC_DISEASES = 'ENDOCRINE_NUTRITIONAL_OR_METABOLIC_DISEASES',
  MENTAL_BEHAVIOURAL_OR_NEURODEVELOPMENTAL_DISORDERS = 'MENTAL_BEHAVIOURAL_OR_NEURODEVELOPMENTAL_DISORDERS',
  SLEEP_WAKE_DISORDERS = 'SLEEP_WAKE_DISORDERS',
  DISEASES_OF_THE_NERVOUS_SYSTEM = 'DISEASES_OF_THE_NERVOUS_SYSTEM',
  DISEASES_OF_THE_VISUAL_SYSTEM = 'DISEASES_OF_THE_VISUAL_SYSTEM',
  DISEASES_OF_THE_EAR_OR_MASTOID_PROCESS = 'DISEASES_OF_THE_EAR_OR_MASTOID_PROCESS',
  DISEASES_OF_THE_RESPIRATORY_SYSTEM = 'DISEASES_OF_THE_RESPIRATORY_SYSTEM',
  DISEASES_OF_THE_CIRCULATORY_SYSTEM = 'DISEASES_OF_THE_CIRCULATORY_SYSTEM',
  DISEASES_OF_THE_DIGESTIVE_SYSTEM = 'DISEASES_OF_THE_DIGESTIVE_SYSTEM',
  DISEASES_OF_THE_SKIN = 'DISEASES_OF_THE_SKIN',
  DISEASES_OF_THE_MUSCULOSKELETAL_SYSTEM_OR_CONNECTIVE_TISSUE = 'DISEASES_OF_THE_MUSCULOSKELETAL_SYSTEM_OR_CONNECTIVE_TISSUE',
  CONDITIONS_RELATED_TO_SEXUAL_HEALTH = 'CONDITIONS_RELATED_TO_SEXUAL_HEALTH',
  DISEASES_OF_THE_GENITOURINARY_SYSTEM = 'DISEASES_OF_THE_GENITOURINARY_SYSTEM',
  PREGNANCY_CHILDBIRTH_OR_THE_PUERPERIUM = 'PREGNANCY_CHILDBIRTH_OR_THE_PUERPERIUM',
  CERTAIN_CONDITIONS_ORIGINATING_IN_THE_PERINATAL_PERIOD = 'CERTAIN_CONDITIONS_ORIGINATING_IN_THE_PERINATAL_PERIOD',
  SYMPTOMS_SIGNS_OR_CLINICAL_FINDINGS_NOT_ELSEWHERE_CLASSIFIED = 'SYMPTOMS_SIGNS_OR_CLINICAL_FINDINGS_NOT_ELSEWHERE_CLASSIFIED',
  CONGENITAL_MALFORMATIONS_DEFORMATIONS_AND_CHROMOSOMAL_ABNORMALITIES = 'CONGENITAL_MALFORMATIONS_DEFORMATIONS_AND_CHROMOSOMAL_ABNORMALITIES',
  DEVELOPMENTAL_ANOMALIES = 'DEVELOPMENTAL_ANOMALIES',
  INJURY_POISONING_OR_CERTAIN_OTHER_CONSEQUENCES_OF_EXTERNAL_CAUSES = 'INJURY_POISONING_OR_CERTAIN_OTHER_CONSEQUENCES_OF_EXTERNAL_CAUSES',
  FACTORS_INFLUENCING_HEALTH_STATUS_OR_CONTACT_WITH_HEALTH_SERVICES = 'FACTORS_INFLUENCING_HEALTH_STATUS_OR_CONTACT_WITH_HEALTH_SERVICES',
  EXTERNAL_CAUSES_OF_MORBIDITY_OR_MORTALITY = 'EXTERNAL_CAUSES_OF_MORBIDITY_OR_MORTALITY',
  CODES_FOR_SPECIAL_PURPOSES = 'CODES_FOR_SPECIAL_PURPOSES',
  SUPPLEMENTARY_CHAPTER_TRADITIONAL_MEDICINE_CONDITIONS = 'SUPPLEMENTARY_CHAPTER_TRADITIONAL_MEDICINE_CONDITIONS',
  SUPPLEMENTARY_SECTION_FOR_FUNCTIONING_ASSESSMENT = 'SUPPLEMENTARY_SECTION_FOR_FUNCTIONING_ASSESSMENT',
  EXTENSION_CODES = 'EXTENSION_CODES',
  CLINICAL_FINDINGS = 'CLINICAL_FINDINGS',
  PROCEDURES = 'PROCEDURES',
  BODY_STRUCTURES = 'BODY_STRUCTURES',
  PHARMACEUTICAL_BIOLOGIC_PRODUCTS = 'PHARMACEUTICAL_BIOLOGIC_PRODUCTS',
  ORGANISMS = 'ORGANISMS',
  OBSERVABLE_ENTITIES = 'OBSERVABLE_ENTITIES',
  ENVIRONMENT_OR_GEOGRAPHICAL_LOCATION = 'ENVIRONMENT_OR_GEOGRAPHICAL_LOCATION',
  SPECIMEN = 'SPECIMEN',
  PHYSICAL_OBJECTS = 'PHYSICAL_OBJECTS',
  SUBSTANCES = 'SUBSTANCES',
  QUALIFIER_VALUE = 'QUALIFIER_VALUE',
  STAGING_AND_SCALES = 'STAGING_AND_SCALES',
  RECORD_ARTEFACTS = 'RECORD_ARTEFACTS',
  OTHER = 'OTHER',
}
